const init = () => {
  if (document.querySelector('[data-print-layout]')) {
    window.print();
  }
};

document.addEventListener('DOMContentLoaded', init);
